// Mock data for Epsilon Executive Education - The AI Career Accelerator

export const siteData = {
  brand: {
    name: "Epsilon",
    tagline: "Executive Education",
  },
  nav: [
    { label: "What We'll Cover", href: "#learn" },
    { label: "Speaker", href: "#speaker" },
    { label: "Programme", href: "#programme" },
    { label: "FAQ", href: "#faq" },
  ],
  hero: {
    eyebrow: "Live Webinar",
    titlePre: "The",
    titleHighlight: "AI Career",
    titlePost: "Accelerator",
    subtitle: "Skills, Roles & Opportunities",
    description:
      "Join global professor and Chief Data Scientist Kent Oliver Bhupathi (formerly NYU & Columbia University) for a live webinar on the AI skills, roles and opportunities shaping the next decade of work.",
    cta: "Reserve My Seat",
  },
  webinar: {
    label: "Webinar Details",
    tag: "Free",
    title: "The AI Career Accelerator",
    subtitle: "A live, interactive 90-minute session with Q&A.",
    dateLabel: "August 2",
    dateSub: "Sunday",
    timeLabel: "12:00 PM",
    timeSub: "Noon IST",
    // ISO target for countdown
    target: "2026-08-02T12:00:00+05:30",
    cta: "Save My Seat",
  },
  credentials: [
    { icon: "GraduationCap", label: "Former NYU Faculty" },
    { icon: "BookOpen", label: "Former Columbia Faculty" },
    { icon: "Briefcase", label: "Chief Data Scientist" },
    { icon: "Building2", label: "15+ Years Industry" },
    { icon: "Radio", label: "Live Interactive" },
  ],
  agenda: {
    eyebrow: "What We'll Cover",
    title: "Everything you need",
    italic: "to accelerate.",
    intro:
      "Five focused takeaways covering the trends, roles, applications and career moves that matter most in AI right now.",
    items: [
      {
        number: "01",
        icon: "BrainCircuit",
        title: "Key AI Trends Shaping Industries And Careers",
        desc: "The macro shifts across enterprises \u2014 what's real, what's noise, and what your team will be judged on next.",
      },
      {
        number: "02",
        icon: "Briefcase",
        title: "High-Growth AI & ML Roles And In-Demand Skills",
        desc: "The exact roles hiring managers are prioritising and the technical + judgment skills that get you shortlisted.",
      },
      {
        number: "03",
        icon: "BarChart3",
        title: "Real-World Applications Driving Business Impact",
        desc: "Case studies of AI applied to revenue, cost and risk \u2014 the pattern behind projects that actually ship.",
      },
      {
        number: "04",
        icon: "Target",
        title: "How To Future-Proof Your Career With AI",
        desc: "A practical playbook for building AI leverage into your role \u2014 without changing companies or waiting for permission.",
      },
      {
        number: "05",
        icon: "GraduationCap",
        title: "Overview Of Epsilon's AI & ML Certificate Program",
        desc: "A look inside the curriculum, mentorship model and placement support designed for senior Indian professionals.",
      },
    ],
    footerNote: "Get exclusive insights into our AI & ML Certificate Program.",
  },
  instructor: {
    eyebrow: "Meet the Speaker",
    firstName: "Kent Oliver",
    lastName: "Bhupathi",
    role: "Chief Data Scientist \u00b7 Economist \u00b7 Educator",
    image:
      "https://customer-assets.emergentagent.com/job_logos-11/artifacts/oimw09re_image.png",
    experienceLabel: "Lead Faculty",
    experienceName: "Kent O. Bhupathi",
    experienceYears: "15+ Years",
    bio1:
      "Kent is an economist and data science leader with 15+ years across marketing science, healthcare analytics, supply chain, BI, litigation and professional services. He became the youngest SVP of Data Science in the history of a \u201cBig Six\u201d marketing firm.",
    bio2:
      "He holds a dual degree in Economics & Architecture from UT Austin and a Master's in Applied Econometrics from NYU. He has taught applied statistics, data science, machine learning and quantitative methods at NYU, Columbia and ISPP.",
    credentials: [
      { icon: "Landmark", label: "Former Faculty, NYU & Columbia University" },
      { icon: "TrendingUp", label: "15+ Years in Data Science, Economics & Analytics" },
      { icon: "UserCircle2", label: "Former SVP of Data Science at a Big Six Firm" },
      { icon: "Trophy", label: "Founder, Epsilon Executive Education" },
    ],
  },
  stats: {
    eyebrow: "Why Attend",
    title: "The cost of waiting",
    italic: "is going up every quarter.",
    items: [
      {
        value: 86,
        suffix: "%",
        label: "of employers",
        desc: "Expect AI and information-processing technologies to transform their business by 2030.",
        source: "World Economic Forum",
      },
      {
        value: 7,
        suffix: "+",
        unit: "hours",
        label: "saved weekly",
        desc: "Saved per week by professionals running disciplined AI workflows.",
        source: "London School of Economics",
      },
      {
        value: 3,
        suffix: "\u00d7",
        label: "faster decisions",
        desc: "Of leaders report significant improvements in decision-making with AI.",
        source: "Harvard Business Impact",
      },
    ],
  },
  programme: {
    eyebrow: "AI & ML Certificate Program",
    title: "Go beyond",
    italic: "the webinar.",
    intro:
      "The webinar is a preview. Epsilon's flagship AI & ML Certificate Program is built for senior professionals who need to make AI useful inside real organisations.",
    features: [
      "Live Instructor-Led Sessions with senior cohorts",
      "1:1 Expert Mentorship and weekly office hours",
      "Industry Projects you can defend in interviews",
      "Job Placement Support across India",
      "Practical AI Applications, not theory dumps",
      "Designed specifically for the Indian market",
    ],
    cta: "Learn More During The Webinar",
  },
  register: {
    eyebrow: "Reserve Your Seat",
    title: "Free registration.",
    italic: "Limited live seats.",
    intro: "Takes under 60 seconds. We'll email your confirmation.",
    statusOptions: [
      "Student",
      "Working Professional",
      "Founder / Entrepreneur",
      "Job Seeker",
      "Other",
    ],
    aiOptions: ["Beginner", "Intermediate", "Advanced", "Not Used Yet"],
    reasonOptions: [
      "Career Security",
      "Productivity",
      "Automation",
      "Business Decision-Making",
      "Career Transition",
      "AI & ML Certificate Program",
    ],
    interestOptions: ["Yes", "Maybe", "No"],
    cta: "Reserve My Seat",
    footnote:
      "By registering you'll receive the joining link via email and WhatsApp before the session. You can unsubscribe at any time.",
  },
  faq: {
    eyebrow: "Questions",
    title: "Everything you",
    italic: "might be wondering.",
    items: [
      {
        q: "Is the webinar really free?",
        a: "Yes. The AI Career Accelerator webinar is completely free to attend. Just register with your details and you'll receive the joining link on email and WhatsApp.",
      },
      {
        q: "Will there be a recording?",
        a: "The session is designed to be experienced live so you can ask questions in real time. A short recap may be shared with registered attendees at Epsilon's discretion.",
      },
      {
        q: "Is coding experience required?",
        a: "No prior coding experience is required. The session is framed around trends, roles and career moves. If you're curious about applying AI at work, you'll get plenty from it.",
      },
      {
        q: "Who should attend?",
        a: "Working professionals, founders, students and career switchers who want to understand where AI careers are heading. Both beginners and experienced practitioners will benefit.",
      },
      {
        q: "How do I join the webinar?",
        a: "Once you register, you'll get a confirmation email with the joining link. We'll also send reminders via WhatsApp before the session begins.",
      },
      {
        q: "Will the AI & ML Certificate Program be discussed?",
        a: "Yes. Kent will spend the final segment walking through Epsilon's flagship AI & ML Certificate Program, including curriculum, mentorship and placement support.",
      },
    ],
  },
  footer: {
    about:
      "Epsilon Executive Education \u2014 turning technical fluency into strategic value. Live online cohorts for senior professionals, based in India.",
    reachTitle: "Reach Us",
    email: "admissions@epsilonexec.com",
    whatsapp: "WhatsApp Us",
    phone: "+91 87963 39323",
    copyright: "\u00a9 2026 Epsilon Executive Education \u00b7 All rights reserved",
  },
};
